import { Header } from '@/components/organisms'
import { isFeatureEnabled } from '@/helpers/featureToggle'
import { useAppDispatch, useAppSelector } from '@/store'
import { resetToastNotifications, selectShellActive, selectShellPath, setShellPath } from '@/store/slices/commonSlice'
import { selectDarkMode } from '@/store/slices/themeSlice'
import { FeatureToggle } from '@/utils/constants/featuresFlag'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import logo from '../../assets/img/logo-pepsico-h.svg'
import { Alert, SidebarMenu } from '../../components/molecules'
import { HeaderExtraItems } from './components/HeaderExtraItems'

export const Template = ({ children }) => {
  return <Logged>{children}</Logged>
}

const Logged = props => {
  const navigate = useNavigate()
  const shellActive = useAppSelector(selectShellActive)
  const shellPath = useAppSelector(selectShellPath)
  const darkMode = useAppSelector(selectDarkMode)
  const dispatch = useAppDispatch()
  const { toastNotifications } = useAppSelector(state => state.common)

  useEffect(() => {
    // important: immediately navigate to shellPath received from the top shell & reset it
    if (shellPath) {
      navigate(shellPath)
      dispatch(setShellPath(''))
    }
  }, [shellPath, navigate, dispatch, toastNotifications])

  const onToastClose = () => {
    dispatch(resetToastNotifications())
  }

  return (
    <>
      {!shellActive && (
        <Header logo={logo} title="Targets">
          {isFeatureEnabled(FeatureToggle.userGuide) && <HeaderExtraItems />}
        </Header>
      )}
      <div data-testid="content" className="relative flex h-full max-h-[calc(100vh-4rem)]">
        {!shellActive && <SidebarMenu />}
        <main
          data-testid="content-main"
          data-cy="content-main"
          className={`${darkMode ? 'dark-mode' : ''} ${shellActive ? 'm-0 p-0' : 'ml-20 pl-7 pr-6 pt-7'} w-full overflow-auto bg-background pb-6 pr-6 pt-7 text-zinc-800`}
          {...props}
        />

        {toastNotifications.show && (
          <Alert
            data-cy="feedback-alert"
            type={toastNotifications.type}
            message={toastNotifications.message}
            show={toastNotifications.show}
            onCloseClick={onToastClose}
          />
        )}
      </div>
    </>
  )
}
